import { useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";
import { ListCategoriesUseCase } from "../../../Usecase/Categories/list-categories-usecase";
import { DestroyCategoriesUseCase } from "../../../Usecase/Categories/destroy-categories-usecase";
import { ICategoryEntity, IListCategoryPayload } from "../../../Services/api/categories/categories.interface";


interface IUseListCategoriesProps {
  listCategoriesUseCase: ListCategoriesUseCase
  destroyCategoriesUseCase: DestroyCategoriesUseCase
}
export function useListCategories({ listCategoriesUseCase, destroyCategoriesUseCase }: IUseListCategoriesProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<ICategoryEntity[]>([])
    const [categoryToDestroy, setCategoryToDestroy] = useState('')
    const [totalRegisters, setTotalRegisters] = useState(1)
   
    const { showToast } =  useToast()

    const listCategories = async ({ page: currentPage  }: IListCategoryPayload) => {
        
        try {
          setLoading(true)
          
          const listResult = await listCategoriesUseCase.handle({page: currentPage});

          if (listResult.isFailure) {
       
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()

         if(list){
            setData(list.data)
            setTotalRegisters(list.total)
         }

    
         setPage(currentPage)
        } catch (error) {
          console.log("error listCategories function: ", error)
        } finally {
          setLoading(false);
        }
      };

    const list = useMemo(() => {
        const rows = data?.map(product => {

            return {
                ...product,
            }
        })

        return rows
    }, [data])

    const handleDestroyCategory = async () => {
        
      try {
        setLoading(true)
        
        const destroyResult = await destroyCategoriesUseCase.handle(categoryToDestroy);

        if (destroyResult.isFailure) {
     
          showToast(String(destroyResult?.error?.error), 'error');
          return;
        }

        setCategoryToDestroy('')
        showToast('Removido com sucesso.', 'success');

       await listCategories({ page })
      } catch (error) {
        console.log("error destroyCategories function: ", error)
      } finally {
        setLoading(false);
      }
    };

      

    return {
        loading,
        listCategories,
        list,
        data,
        setCategoryToDestroy,
        categoryToDestroy,
        handleDestroyCategory,
        totalRegisters
        
    }
}